import React from 'react';
import 'materialize-css';
import { RouteNames } from '../../../shared/enums/RouteNames';
import SharedHistory from '../../../shared/History';
import { Navbar, Icon, NavItem, Dropdown } from 'react-materialize';
import { Bird, Compass, BirdBox, ManageUsers, Binoculars } from '../../../constants/Icons';
import './NavBar.scss';
import { IconNames } from '../../../shared/enums/IconNames';
import { RouteRules } from '../../../shared/RouteRules';
import { useTypedSelector } from '../../../hooks/useTypedSelectors';

const generateSideNavElement = (Svg: JSX.Element, displayText: string, routeName: RouteNames): JSX.Element => {
  const clickHandler = (e: React.MouseEvent<HTMLElement>) => navClickHandler(e, routeName);
  const route = window.location.pathname;
  const isSelected = route === routeName;

  return (
    <div
      key={displayText}
      onClick={clickHandler}
      aria-label={displayText}
      className={'side-nav-element' + (isSelected ? ' selected' : '')}
    >
      <div className='side-nav-container'>
        <div className='side-nav-icon'>{Svg}</div>
        <p className='side-nav-description'>{displayText}</p>
      </div>
    </div>
  );
};

const navClickHandler = (e: React.MouseEvent<HTMLElement>, newRoute: RouteNames) => {
  const route = window.location.pathname;
  if (route === newRoute) return;
  SharedHistory.push(newRoute);
};

const withNavBar = (Comp: React.ComponentType, useSideNavIcons = false) => {
 const HocWithNavBar = () => {
  const user = useTypedSelector((store) => store.User?.UserObject);
const title = (
<div className='logo-container'>
        <p className='title' id='i-track-title'>
          iTrack{' '}
        </p>
        <p className='title' id='habitat-title'>
          Habitat
        </p>
      </div>
    );
    const topNav = (
      <Navbar
        alignLinks='right'
        brand={title}
        id='itrack-nav'
        className='header-nav'
        menuIcon={<Icon>menu</Icon>}
        options={{ edge: 'left' }}
      >
        <NavItem onClick={(e) => navClickHandler(e, RouteNames.Info)} data-testid='help-icon' className='nav-icon'>
          <Icon className='icon'>{IconNames.Help}</Icon>
        </NavItem>
        <Dropdown
          options={{
            alignment: 'left',
            closeOnClick: true,
            constrainWidth: false,
            container: null,
            hover: false,
            outDuration: 0,
          }}
          trigger={
            <a href='#!' className='dropdown-btn'>
              <Icon className='icon'>{IconNames.AccountCircle}</Icon>
            </a>
          }
        >
          <span className='dropdown-title'>{ RouteRules.GetUserIdTokenInfo(user, 'given_name') }</span>
          {/* <a href={window.location.toString().split('/')[0] + RouteNames.MyProfile}>My Profile</a> */}
          <a
            className='profile-nav-link'
            data-testid='profile-icon'
            onClick={(e) => navClickHandler(e, RouteNames.MyProfile)}
          >
            My Profile
          </a>
          <a
            className='preference-nav-link'
            data-testid='preference-icon'
            onClick={(e) => navClickHandler(e, RouteNames.UserPreferences)}
          >
            App Preferences
          </a>
        </Dropdown>
        <NavItem href='#' className='nav-icon'>
          <Icon className='icon'>{IconNames.Elipses}</Icon>
        </NavItem>
      </Navbar>
    );

    const isUserAdmin = RouteRules.IsAdminUser(user);
    const manageUsersElement = generateSideNavElement(ManageUsers, 'Manage Users', RouteNames.ManageUsers);
    const ManageHabitatsElement = generateSideNavElement(BirdBox, 'Manage Habitats', RouteNames.ManageHabitats);
    const compassElement = generateSideNavElement(Compass, 'Saved Observations', RouteNames.Observations);
    const addObservationElement = generateSideNavElement(Binoculars, 'New Observation', RouteNames.CreateObservations);

    const adminNavIcons: JSX.Element[] = isUserAdmin ? [ManageHabitatsElement, manageUsersElement] : [];
    const sideNavIcons: JSX.Element[] | undefined = !useSideNavIcons ? undefined : [addObservationElement, compassElement, ...adminNavIcons];

    const sideNav = <div className='side-nav'>{sideNavIcons}</div>;
    const home = (
      <div className='home' title='home-link' onClick={(e) => navClickHandler(e, RouteNames.Login)}>
        {Bird}
      </div>
    );

    return (
      <div>
        <div className='top-nav'>
          {home}
          {topNav}
        </div>
        {sideNav}
        <div className='content-container'>
          <Comp />
        </div>
      </div>
    );
  };
  return HocWithNavBar;
};

export { withNavBar };
